import { API_ROUTES_FOR_AXIOS } from 'src/constants/ApiRoutes';
import { axiosInstance } from 'src/constants/axiosInstance';
import { ApiResponse } from 'src/types/commonResponseTypes';
import { handleError } from 'src/utils/commonErrorUtils';

/** Verify the current user's exact Picker grant without ingesting or sharing. */
export async function verifyDriveFileAccess(
  fileId: string,
): Promise<ApiResponse<{ fileId: string }>> {
  try {
    const { data } = await axiosInstance.get<ApiResponse<{ fileId: string }>>(
      API_ROUTES_FOR_AXIOS.verifyDriveFileAccess(),
      { params: { fileId } },
    );

    return data;
  } catch (error) {
    return handleError(error);
  }
}
